// @ts-nocheck

import { get } from 'lodash'
import moment, { Moment } from 'moment'
import React from 'react'

import { TValueDatePicker } from '../helpers'

type TDateDisplay = {
  date: Moment
  fallbackText: string
  timepicker: boolean
}

const DateDisplay = (props: TDateDisplay): React.ReactElement => {
  const { date, fallbackText, timepicker } = props
  if (date) {
    return <>{moment(date).format(`DD.MM.YYYY${timepicker ? ' HH:mm' : ''}`)}</>
  }
  return <>{fallbackText}</>
}

type TButton = {
  value: TValueDatePicker
  isRange: boolean
  timepicker: boolean
  placeholder?: string
}

const Button = (props: TButton): React.ReactElement => {
  const { value, isRange, timepicker, placeholder } = props
  const startDate = get(value, 'startDate')
  return (
    <div className="d-flex justify-content-between align-items-center">
      <i className="fas fa-calendar-alt" />{' '}
      <span style={{ whiteSpace: 'nowrap' }}>
        {moment
          .unix(0)
          .isSame(moment(isRange ? startDate : (value as string))) ? (
          <span>Unbeschränkt</span>
        ) : (
          <React.Fragment>
            <span className="ml-2 mr-2">
              <DateDisplay
                timepicker={timepicker}
                fallbackText={
                  placeholder ??
                  (isRange
                    ? i18n.t(`choose_start_date`, `Start wählen`)
                    : i18n.t(`choose_date_fallback`, `Datum wählen`))
                }
                date={isRange ? get(value, 'startDate') : (value as string)}
              />
            </span>
            {isRange && (
              <span>
                &mdash;
                <span className="ml-2 mr-2">
                  <DateDisplay
                    timepicker={timepicker}
                    fallbackText={i18n.t(`choose_end_date`, `Ende wählen`)}
                    date={get(value, 'endDate')}
                  />
                </span>
              </span>
            )}
          </React.Fragment>
        )}
      </span>
      <i className="fas fa-chevron-down" />
    </div>
  )
}

export default Button
